import { Auth } from 'aws-amplify';

// eslint-disable-next-line import/prefer-default-export
export async function getAuthHeader() {
  const currentUser = await Auth.currentAuthenticatedUser();
  const tok = currentUser.signInUserSession.idToken;
  // console.log(tok);
  const hdr = {
    Authorization: `Bearer ${tok.jwtToken}`,
  };
  return hdr;
}
